import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import { FaShoppingBasket, FaHeart, FaTimes } from "react-icons/fa";
import {
  Grid,
  makeStyles,
  Button,
  Box,
  Dialog,
  DialogContent,
  IconButton,
} from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import { backend } from "../../../api";
import { Skeleton } from "@material-ui/lab";
import { AiFillRead } from "react-icons/ai";
import CreateAdCard from "./CreateAdCard";
import Swal from "sweetalert2";
import axios from "axios";
import { useMyContext } from "../../../contextApi/context";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

const useStyles = makeStyles((theme) => ({
  Title: {
    fontSize: "36px",
    fontWeight: "600",
    marginTop: "0px",
  },
  input: {
    padding: 15,
    borderRadius: "2px",
  },
  priceTag: {
    margin: 0,
  },
  addBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    fontSize: "12px",
    height: "100%",
    fontWeight: "600",
    borderRadius: "2px",
    padding: "10px 0",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
  toastBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    textDecoration: "none",
    marginLeft: "20px",
  },
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  checkboxInput: {
    appearance: "none",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    border: `2px solid ${theme.palette.secondary.main}`,
    outline: "none",
    marginRight: theme.spacing(1),
    cursor: "pointer",
    position: "relative",
    transition: "border-color 0.2s ease-in-out",
    "&:checked": {
      borderColor: theme.palette.primary.main,
      "&::after": {
        content: '""',
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "10px",
        height: "10px",
        borderRadius: "50%",
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
  checkboxLabel: {
    fontSize: "18px",
  },
  Description: {
    fontSize: "16px",
    lineHeight: 1.5,
    margin: "10px 0",
    whiteSpace: "pre-wrap",
    textAlign: "justify",
  },
  quantityContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  quantityButton: {
    color: theme.palette.secondary.light,
    border: `1px solid ${theme.palette.primary.main}`,
    display: "flex",
    borderRadius: "5px",
    padding: "5px",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    transition: "background-color 0.3s, color 0.3s",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
  quantityInput: {
    border: "none",
    padding: "8px",
    width: "50px",
    textAlign: "center",
  },
  bookCoverContainer: {
    position: "relative",
    width: "100%",
    maxWidth: "300px",
    height: "auto",
    margin: "0 auto",
    overflow: "hidden",
    flex: "0 0 auto",
  },
  modalImage: {
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain",
  },
  modalContent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    height: "100vh",
  },
  closeButton: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
    color: theme.palette.primary.main,
  },
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: theme.spacing(2),
    gap: theme.spacing(2),
  },
  content: {
    maxWidth: "700px",
    padding: theme.spacing(2),
  },
  imageContainer: {
    maxWidth: "350px",
    marginTop: theme.spacing(12.6),
    marginRight: theme.spacing(2),
    alignSelf: "flex-start",
  },
  flexContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
  },
  bookDescription: {
    flex: 1,
    marginLeft: theme.spacing(2),
  },
}));

function MainAdminBookDetail(props) {
  const { currentBook, wishlist, user, author, cartItems, isDisable } = props;
  const { setCartItems, setBook } = useMyContext();
  const classes = useStyles();
  const logInUser = user.user
    ? user.user.role //customer
    : user.author
    ? user.author.role //author
    : user.role; //member
  const [bookOrder, setBookOrder] = useState({});
  const history = useHistory();
  const [favorite, setFavorite] = useState(false);
  const [bookType, setBookType] = useState();
  const [quantity, setQuantity] = useState(1);
  const [disableAddToCart, setDisableAddToCart] = useState(false);
  const [disableAddToWishlist, setDisableAddToWishlist] = useState(false);
  const [disableRemoveWishlist, setDisableRemoveWishlist] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  console.log("currentBook", currentBook);

  useEffect(() => {
    handleFetchCurrentBookOrder();
  }, []);

  useEffect(() => {
    if (wishlist) {
      let favorite = wishlist.book.find(
        (book) => book._id === currentBook?._id
      );
      if (favorite) {
        setFavorite(true);
      } else {
        setFavorite(false);
      }
    }
  }, [wishlist]);

  const handleBookType = (e) => {
    setBookType(e.target.value);
  };

  const checkoutChoice = () => {
    Swal.fire({
      title: "Checkout Choice",
      showCancelButton: true,
      showConfirmButton: true,
      cancelButtonText: "E-book",
      confirmButtonText: "Home Delivery",
    }).then((value) => {
      if (value.isConfirmed) {
        history.push(
          `${process.env.PUBLIC_URL}/book/${currentBook?._id}/checkoutwithaddress`
        );
      }
      if (value.isDismissed) {
        history.push(
          `${process.env.PUBLIC_URL}/book/${currentBook?._id}/checkoutEbook`
        );
      }
    });
  };

  const handleWishListAdd = () => {
    if (!disableAddToWishlist) {
      setDisableAddToWishlist(true);
      const newWishlist = {
        book: currentBook?._id,
        date_updated: new Date(),
      };
      backend
        .put(`/wishlist/${wishlist._id}`, newWishlist)
        .then((res) => {
          if (res.data.message === "Wishlist Record Updated") {
            toast.success("Book Added to Wishlist");
          }
          setFavorite(true);
        })
        .catch((err) => {
          let message = err.response ? err.response.data.message : err.message;
          toast.error(message);
        })
        .finally(() => {
          setDisableAddToWishlist(false);
        });
    }
  };

  const handleWishlistRemove = () => {
    if (!disableRemoveWishlist) {
      setDisableRemoveWishlist(true);

      const newWishlist = {
        book: currentBook?._id,
        date_updated: new Date(),
      };
      backend
        .put(`/wishlist/${wishlist._id}/remove`, newWishlist)
        .then((res) => {
          if (res.data.message === "Wishlist Record Updated") {
            toast.warn("Book removed from wishlist");
          }
          setFavorite(false);
        })
        .catch((err) => {
          let message = err.response ? err.response.data.message : err.message;
          toast.error(message);
        })
        .finally(() => {
          setDisableRemoveWishlist(false);
        });
    }
  };

  const handleFetchCurrentBookOrder = () => {
    backend
      .get(`/bookOrder?book=${currentBook?._id}&user=${user._id}`)
      .then((res) => {
        setBookOrder(
          res.data.data.find((order) => order.book_price.digital_price)
        );
      })
      .catch((err) => {
        let message = err.response ? err.response.data.message : err.message;
      });
  };

  const handleQuantityChange = (action) => {
    setQuantity((prevQuantity) => {
      if (action === "increment") {
        return prevQuantity + 1;
      }
      if (action === "decrement" && prevQuantity > 1) {
        return prevQuantity - 1;
      }
      return prevQuantity;
    });
  };

  const handleAddToCart = () => {
    if (!disableAddToCart) {
      setDisableAddToCart(true);

      const { _id } = currentBook;
      const token = localStorage.getItem("Token");
      try {
        backend
          .post(
            "/shopCart",
            {
              bookId: currentBook._id,
              cartItemType: "BOOK",
              bookOrderType: bookType,
              quantity:
                bookType === "HARDCOPY" || bookType === "BOTH"
                  ? quantity
                  : null,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((response) => {
            backend
              .get("/shopCart")
              .then((response) => {
                setCartItems(response?.data?.data);
                setBook(response?.data);
                toast.success("Item added to cart successfully");
                history.push("/shopping-cart");
              })
              .catch((error) => {
                toast.error(error.message);
              });
          })
          .catch((error) => {
            console.log(error);
            toast.error(error.message);
          });
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const ToastBox = () => {
    return (
      <div>
        CART UPDATED
        <Link to="/cart" style={{ textDecoration: "none" }}>
          <Button
            variant="contained"
            className={classes.toastBtn}
            endIcon={<FaShoppingBasket />}
          >
            View Cart
          </Button>
        </Link>
      </div>
    );
  };

  const renderQuantityControls = () => {
    if (bookType === "HARDCOPY" || bookType === "BOTH") {
      return (
        <div className={classes.quantityContainer}>
          <Button
            className={classes.quantityButton}
            onClick={() => handleQuantityChange("decrement")}
          >
            -
          </Button>
          <input
            type="text"
            className={classes.quantityInput}
            value={quantity}
            readOnly
          />
          <Button
            className={classes.quantityButton}
            onClick={() => handleQuantityChange("increment")}
          >
            +
          </Button>
        </div>
      );
    }
    return null;
  };

  return (
    <Box>
      <ToastContainer />
      {currentBook && author ? (
        <div className={classes.container}>
          <div className={classes.imageContainer}>
            <Zoom>
              <img
                src={currentBook?.book_cover}
                alt=""
                style={{
                  width: "100%",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            </Zoom>
          </div>
          <div className={classes.content}>
            <h1 className={classes.Title}>{currentBook?.book_title}</h1>
            <p className={classes.Description}>{currentBook?.book_story}</p>
            {currentBook?.price && (
              <Box my={4}>
                {currentBook?.price.hardcover_price && (
                  <div className={classes.checkboxContainer}>
                    {logInUser !== "author" ? (
                      <input
                        type="radio"
                        id="hardcover"
                        name="bookType"
                        value="HARDCOPY"
                        className={classes.checkboxInput}
                        onClick={handleBookType}
                      />
                    ) : null}
                    <label
                      htmlFor="hardcover"
                      className={classes.checkboxLabel}
                    >
                      Hard Cover Price: {currentBook?.price.hardcover_price}$
                    </label>
                  </div>
                )}
                {currentBook?.price.paperback_price && (
                  <div className={classes.checkboxContainer}>
                    {logInUser !== "author" ? (
                      <input
                        type="radio"
                        id="paperback"
                        name="bookType"
                        value="PAPERBACK"
                        className={classes.checkboxInput}
                        onClick={handleBookType}
                      />
                    ) : null}
                    <label
                      htmlFor="paperback"
                      className={classes.checkboxLabel}
                    >
                      Paper Back Price: {currentBook?.price.paperback_price}$
                    </label>
                  </div>
                )}
                {currentBook?.price.digital_price && (
                  <div className={classes.checkboxContainer}>
                    {logInUser !== "author" ? (
                      <input
                        type="radio"
                        id="ebook"
                        name="bookType"
                        value="EBOOK"
                        className={classes.checkboxInput}
                        onClick={handleBookType}
                      />
                    ) : null}
                    <label htmlFor="ebook" className={classes.checkboxLabel}>
                      Digital Ebook Price: {currentBook?.price.digital_price}$
                    </label>
                  </div>
                )}
                {currentBook?.price.hardcover_price &&
                  currentBook?.price.digital_price && (
                    <div className={classes.checkboxContainer}>
                      {logInUser !== "author" ? (
                        <input
                          type="radio"
                          id="both"
                          name="bookType"
                          value="BOTH"
                          className={classes.checkboxInput}
                          onClick={handleBookType}
                        />
                      ) : null}
                      <label htmlFor="both" className={classes.checkboxLabel}>
                        Both Hard Cover and Digital Ebook:{" "}
                        {currentBook?.price.both_price}$
                      </label>
                    </div>
                  )}
              </Box>
            )}
            {renderQuantityControls()}
            {logInUser && logInUser === "member" ? (
              <CreateAdCard book={currentBook} member={user} />
            ) : (
              <Grid container spacing={2}>
                {wishlist && (
                  <Grid item xs={12} md={6}>
                    {favorite ? (
                      <Button
                        className={classes.addBtn}
                        startIcon={<FaHeart />}
                        onClick={handleWishlistRemove}
                        fullWidth
                      >
                        Remove from Wishlist
                      </Button>
                    ) : (
                      <Button
                        className={classes.addBtn}
                        startIcon={<FaHeart />}
                        onClick={handleWishListAdd}
                        fullWidth
                      >
                        {disableAddToWishlist
                          ? "Adding to Wishlist"
                          : "Add to Wishlist"}
                      </Button>
                    )}
                  </Grid>
                )}
                {logInUser == "customer" && (
                  <Grid item xs={12} md={6}>
                    <Button
                      className={classes.addBtn}
                      startIcon={<FaShoppingBasket />}
                      onClick={(event) => handleAddToCart(event)}
                      fullWidth
                      disabled={!bookType || isDisable}
                    >
                      {isDisable
                        ? "Already in cart"
                        : disableAddToCart
                        ? "Adding to Cart"
                        : currentBook?.pre_order
                        ? "Pre-Order Now"
                        : "Add to Cart"}
                    </Button>
                  </Grid>
                )}
              </Grid>
            )}
            {currentBook?.book_category &&
              currentBook?.book_category?.length > 0 && (
                <p>
                  <span
                    className={classes.Description}
                    style={{ fontWeight: "bold" }}
                  >
                    Categories:{" "}
                  </span>
                  {currentBook?.book_category?.map((category, index) => (
                    <span key={index}>
                      {category.category_name}
                      {index < currentBook.book_category.length - 1 ? ", " : ""}
                    </span>
                  ))}
                </p>
              )}
            <Grid>
              <h1 className={classes.Title}>About the Author</h1>
              <h2
                className={classes.Description}
                style={{ fontWeight: "bold" }}
              >
                {currentBook?.authorDetail?.name}
              </h2>
              <p
                className={classes.Description}
                style={{ textAlign: "justify" }}
              >
                {currentBook?.authorDetail?.description}
              </p>
            </Grid>
          </div>
        </div>
      ) : (
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6} lg={5}>
              <Skeleton
                variant="rect"
                width="60%"
                height={450}
                style={{ margin: "0 auto" }}
                animation
              />
            </Grid>
            <Grid xs={12} sm={6} md={6} lg={7}>
              <Skeleton
                variant="rect"
                width="90%"
                height={100}
                animation="wave"
              />
              <Skeleton
                animation="wave"
                width="90%"
                style={{ marginTop: 40 }}
              />
              <Skeleton animation="wave" width="75%" />
              <Skeleton animation="wave" width="60%" />
              <Skeleton animation="wave" width="45%" />

              <Skeleton
                animation="wave"
                width={200}
                height={40}
                style={{ marginTop: 30 }}
              />
              <Skeleton animation="wave" width={200} height={40} />
              <Skeleton animation="wave" width={200} height={40} />

              <Box display="flex" mt={5}>
                <Skeleton
                  variant="rect"
                  width="40%"
                  height={40}
                  animation="wave"
                />
                <Skeleton
                  variant="rect"
                  width="40%"
                  height={40}
                  style={{ marginLeft: 20 }}
                  animation="wave"
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        maxWidth="md"
        fullWidth
      >
        <DialogContent className={classes.modalContent}>
          <IconButton
            className={classes.closeButton}
            onClick={handleCloseModal}
          >
            <FaTimes />
          </IconButton>
          <img
            src={currentBook?.book_cover}
            alt="Book Cover"
            className={classes.modalImage}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default MainAdminBookDetail;
